import Router from '../Router';
import { CompsController } from '../../controllers';

export default class CompsRouter extends Router {
	initialize( options ) {
		this.typeMenu   = 'comps';
		this.controller = new CompsController( options );
	}

	get appRoutes() {
		return {
			'comps/my-comps':                      'myComps',
			'comps/create':                        'compsCreate',
			'comps/:comp_id/congratulation':       'compCongratulation',
			'comps/join(/)(?code=:code)':          'joinComps',
			'comps/:league_id/manage':             'compSettings',
			'comps/:id/invites':                   'invitesAfterCreateComp',
			'comps/:league_id/manage/invites':     'compInvites',
			'comps/:league_id/ladder':             'compLadder',
			'comps/regeneration':                  'compsRegenerateList',
			'comps/:id/regenerate':                'compRegenerate',
			'comps/:id/regenerate/invite/:old_id': 'compRegenerateInvites',
			'comps/:id/regenerate/congratulation': 'compRegenerateCongratulation'
		};
	}
}